
import APP_CONFIG from './App'
import i18n from '../lang/index'


var TipsList = {
  'AxiosError: Network Error': {
    code: '',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('网络异常,请检查网络'),
      en: 'Network Error'
    },
    visible: true
  },
  'AxiosError: Request failed with status code 502': {
    code: '',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('服务器访问异常'),
      en: 'Request failed with status code 502'
    },
    visible: true
  },
  'AxiosError: timeout of ms exceeded': {
    code: '',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('连接服务器超时({number}秒)', { number: APP_CONFIG.timeout / 1000 }),
      en: 'Error: timeout of ' + APP_CONFIG.timeout + 's exceeded'
    },
    visible: true
  },
  'AxiosError: 404 Not Found': {
    code: '',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('网页未找到'),
      en: '404 Not Found'
    },
    visible: true
  },
  'Error: Network Error': {
    code: '',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('网络异常,请检查网络'),
      en: 'Network Error'
    },
    visible: true
  },
  'Error: Request failed with status code 502': {
    code: '',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('服务器访问异常'),
      en: 'Request failed with status code 502'
    },
    visible: true
  },
  'Error: timeout of ms exceeded': {
    code: '',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('连接服务器超时({number}秒)', { number: APP_CONFIG.timeout / 1000 }),
      en: 'Error: timeout of ' + APP_CONFIG.timeout + 's exceeded'
    },
    visible: true
  },
  'Error: 404 Not Found': {
    code: '',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('网页未找到'),
      en: '404 Not Found'
    },
    visible: true
  },
  'i/o timeout': {
    code: '',
    erroe: 'work:i/o timeout',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('无法连接服务器'),
      en: 'unable to connect to the server',
    },
    visible: true,
  },
  'vcode:not found': {
    code: '',
    error: 'vcode:not found',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('此手机号暂未注册'),
      en: 'this number is not found'
    },
    visible: true
  },
  'vcode:account not found': {
    code: '',
    error: 'vcode:account not found',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('此手机号暂未注册'),
      en: 'this number is not found'
    },
    visible: true
  },
  'vcode:手机号日频率限制': {
    code: '',
    error: 'vcode:手机号日频率限制',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('手机号日频率限制'),
      en: 'daily frequency limit for phone numbers'
    },
    visible: true
  },
  'vcode:手机号1小时频率限制': {
    code: '',
    error: 'vcode:手机号1小时频率限制',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('手机号1小时频率限制'),
      en: 'an hour frequency limit for phone numbers'
    },
    visible: true
  },
  'vcode:to receive a new code, wait at least 60 seconds': {
    code: '',
    error: 'vcode:to receive a new code, wait at least 60 seconds',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('请等待60s后再获取新验证码'),
      en: 'to receive a new code, wait at least 60 seconds'
    },
    visible: true
  },
  'vemail:account not found': {
    code: '',
    error: 'vemail:account not found',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('此邮箱地址暂未注册'),
      en: 'this email is not found'
    },
    visible: true
  },
  'vemail:to send a new verification email, wait at least one minute': {
    code: '',
    error: 'vemail:to send a new verification email, wait at least one minute',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('发送验证邮件失败，请稍后再试'),
      en: 'to send a new verification email, wait at least one minute'
    },
    visible: true
  },
  'vemail:unknown error': {
    code: '',
    error: 'vemail:unknown error',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('发送验证邮件失败，请稍后再试'),
      en: 'failed to send verification mail. please try again later'
    },
    visible: true
  },
  'login:the user account has been locked': {
    code: '',
    error: 'login:the user account has been locked',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('账号被锁定, 请使用密码找回功能重置密码'),
      en: 'the user account has been locked'
    },
    visible: true
  },
  'login:user has unknown role': {
    code: '',
    error: 'login:user has unknown role',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('无权登录，请联系管理员授权'),
      en: 'user has unknown role'
    },
    visible: true
  },
  'login:incorrect Username or Password': {
    code: '',
    error: 'login:incorrect Username or Password',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('用户名或密码错误'),
      en: 'incorrect Username or Password'
    },
    visible: true
  },
  'login:not found': {
    code: '',
    error: 'login:not found',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('没有找到该用户'),
      en: 'not found'
    },
    visible: true
  },
  'login:user not found': {
    code: '',
    error: 'login:user not found',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('没有找到该用户'),
      en: 'user not found'
    },
    visible: true
  },
  'login:account not found': {
    code: '',
    error: 'login:account not found',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('没有找到该用户,请重新登录'),
      en: 'account not found'
    },
    visible: true
  },
  'login:no rights or no roles': {
    code: '',
    error: 'login:no rights or no roles',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('您没有权限登录!'),
      en: 'login:no rights or no roles'
    },
    visible: true
  },
  'login:token is expired': {
    code: '',
    error: 'login:token is expired',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('当前登录无效!'),
      en: 'login:token is expired'
    },
    visible: true
  },
  'login:tenant access denied': {
    code: '',
    error: 'login:tenant access denied',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('无权访问当前厂家，请重新登录'),
      en: 'tenant access denied'
    },
    visible: true
  },
  'login:user password changed': {
    code: '',
    error: 'login:user password changed',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('用户密码已修改，请重新登录'),
      en: 'user password changed'
    },
    visible: true
  },
  'login:please switch to actual tenant': {
    code: '',
    error: 'login:please switch to actual tenant',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('您已经成为厂家正式用户，请重新登录'),
      en: 'please switch to actual tenant'
    },
    visible: true
  },
  'login:the user account no tenant': {
    code: '',
    error: 'login:the user account no tenant',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('当前账号不属于任何租户，租户信息可能正在审核中，请等待!'),
      en: 'the user account no tenant'
    },
    visible: true
  },
  'login:verification code error': {
    code: '',
    error: 'login: verification code error',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('验证码错误'),
      en: 'verification code error'
    },
    visible: true
  },
  'login:signature is invalid': {
    code: '',
    error: 'login: signature is invalid',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('登录已过期，需要重新登录'),
      en: 'signature is invalid'
    },
    visible: true
  },
  'router:change page abnormally': {
    code: '',
    error: 'router:change page abnormally',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('请不要非正常切换页面'),
      en: 'change page abnormally'
    },
    visible: true
  },
  'message:': {
    code: '',
    erroe: 'message:',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('消息创建失败:服务端无错误信息'),
      en: 'message:'
    },
    visible: true
  },
  'file:no file found, the filename should like file1,file2,file3...': {
    code: '',
    erroe: 'file:no file found, the filename should like file1,file2,file3...',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('没有找到可以上传的文件'),
      en: 'no file found, the filename should like file1,file2,file3...'
    },
    visible: true
  },
  'unknown error': {
    code: '',
    error: 'unknown error',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('未能解析的错误'),
      en: 'unknown error'
    },
    visible: true
  },
  'work:customer\'s eds-server API URL not specified': {
    code: '',
    erroe: 'work:customer\'s eds-server API URL not specified',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('客户eds-server服务地址未指定'),
      en: 'customer\'s eds-server API URL not specified'
    },
    visible: true
  },
  'work:task state error': {
    code: '',
    erroe: 'work:task state error',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('任务状态错误，该任务已被处理'),
      en: 'task state error'
    },
    visible: true
  },
  'work:flow not found': {
    code: '',
    erroe: 'work:flow not found',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('该流程不存在，可能已被申请人删除'),
      en: 'flow not found'
    },
    visible: true
  },
  'work:flow state error': {
    code: '',
    erroe: 'work:flow state error',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('流程状态错误'),
      en: 'flow state error'
    },
    visible: true
  },
  'work:request to eds-svc error': {
    code: '',
    erroe: 'work:request to eds-svc error',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('无法连接至企业端接口服务'),
      en: 'unable to connect to enterprise interface service',
    },
    visible: true,
  },
  'work:request to eds-pro error': {
    code: '',
    erroe: 'work:request to eds-pro error',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('无法连接至企业端接口服务'),
      en: 'unable to connect to enterprise interface service',
    },
    visible: true,
  },
  'work:workflow not found': {
    code: '',
    erroe: 'work:workflow not found',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('流程不存在'),
      en: 'workflow not found'
    },
    visible: true
  },
  'connectex: No connection could be made because the target machine actively refused it': {
    code: '',
    erroe: 'connectex: No connection could be made because the target machine actively refused it',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('服务连接失败'),
      en: 'No connection could be made because the target machine actively refused it'
    },
    visible: true
  },
  'customer\'s eds-server app-key not specified': {
    code: '',
    erroe: 'customer\'s eds-server app-key not specified',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('客户的EDS服务器App-Key未提供'),
      en: 'customer\'s eds-server app-key not specified'
    },
    visible: true
  },
  'get eds service app-key token error': {
    code: '',
    erroe: 'get eds service app-key token error',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('获取App-Key错误'),
      en: 'get eds service app-key token error'
    },
    visible: true
  },
  '文件不存在': {
    code: '',
    erroe: '文件不存在',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('文件不存在'),
      en: 'file does not exist'
    },
    visible: true
  },
  '检查文件时出错': {
    code: '',
    erroe: '检查文件时出错',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('检查文件时出错'),
      en: 'error checking file'
    },
    visible: true
  },
  'signature is invalid': {
    code: '',
    erroe: 'signature is invalid',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('验证失败，请重新登录'),
      en: 'signature is invalid'
    },
    visible: true
  },
  'customer user not found': {
    code: '',
    erroe: 'customer user not found',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('客户用户不存在'),
      en: 'customer user not found'
    },
    visible: true
  },
  'record not found': {
    code: '',
    erroe: 'record not found',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('记录不存在'),
      en: 'record not found'
    },
    visible: true
  },
  'generate user token error': {
    code: '',
    erroe: 'generate user token error',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('生成用户令牌出错'),
      en: 'generate user token error'
    },
    visible: true
  },
  'the interface does not support the current version': {
    code: '',
    erroe: 'the interface does not support the current version',
    color: 'error',
    type: 'error',
    text: {
      cn: i18n.t('当前版本不支持'),
      en: 'the interface does not support the current version'
    },
    visible: true
  },
}

export default TipsList
